import { ModelBase } from '../../abstract/model-base.model';

/**
 * Mentions d'un compte bancaire mises en forme par le back pour être insérées dans les
 * coordonnées bancaires des réglages de vente (#964). Lecture seule : servi dans
 * `BankAccount.insertableBankDetails`, `null` sur un compte sans IBAN.
 *
 * Chaque mention est `null` quand elle manque ; `fullBlock` ne porte que les lignes
 * présentes. `holder` est toujours renseigné (raison sociale du dossier à défaut).
 * Contrat : `b4cash-srv/documentation/banking/BANK_ACCOUNT_BANK_DETAILS.md` §4.
 */
export class InsertableBankDetails extends ModelBase {

    static override CLASS_NAME: string = 'InsertableBankDetails';

    private _bic!: string | null;
    private _domiciliation!: string | null;
    private _fullBlock!: string;
    private _holder!: string;
    private _iban!: string;

    public get bic(): string | null {
        return this._bic;
    }

    public set bic(value: any) {
        this._setValue('_bic', value, 'string');
    }

    public get domiciliation(): string | null {
        return this._domiciliation;
    }

    public set domiciliation(value: any) {
        this._setValue('_domiciliation', value, 'string');
    }

    public get fullBlock(): string {
        return this._fullBlock;
    }

    public set fullBlock(value: any) {
        this._setValue('_fullBlock', value, 'string');
    }

    public get holder(): string {
        return this._holder;
    }

    public set holder(value: any) {
        this._setValue('_holder', value, 'string');
    }

    public get iban(): string {
        return this._iban;
    }

    public set iban(value: any) {
        this._setValue('_iban', value, 'string');
    }
}
